import { useEffect } from "react";

import { useLocation } from "react-router-dom";

import { Header } from "@sso/components/Header";
import { MainContent } from "@sso/components/MainContent";
import { Sidebar } from "@sso/components/Sidebar";
import { useAppDispatch, useAppSelector } from "@sso/hooks/useRedux";
import { selectCurrentUser } from "@sso/store/slices/auth";
import { selectDrawerState, setDrawerOpen } from "@sso/store/slices/drawer";
import { Flex } from "@sso/ui/FlexBox";

import { LoadingApp } from "../LoadingApp";

export const Home = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { open: drawerOpen } = useAppSelector(selectDrawerState);
  const handleDrawerToggle = () => dispatch(setDrawerOpen(!drawerOpen));

  const isPaymentPage = location.pathname === "/payment" || location.pathname === "/return" || location.pathname.includes("purchase");
  useEffect(() => {
    if (isPaymentPage) {
      dispatch(handleDrawerToggle());
    }
  }, []);

  const user = useAppSelector(selectCurrentUser);

  return (
    <>
      {user || isPaymentPage ? (
        <Flex position="relative">
          {!isPaymentPage && (
            <>
              <Header setDrawerToggle={handleDrawerToggle} />
              <Sidebar setDrawerToggle={handleDrawerToggle} drawerOpen={drawerOpen} />
            </>
          )}

          <MainContent drawerOpen={drawerOpen} />
        </Flex>
      ) : (
        <LoadingApp />
      )}
    </>
  );
};
